<template>
    <Teleport to="body">
        <div
            class="fixed left-0 z-40 overflow-y-auto bg-white p-7 shadow-lg duration-300"
            :class="{
                'invisible opacity-0': !active,
                'visible translate-x-0 translate-y-0 opacity-100': active,
                'translate-x-full': direction === 'from-right' && !active,
                '-translate-x-full': direction === 'from-left' && !active,
                'translate-y-full': direction === 'from-bottom' && !active,
                'z-50': !hasManualDrawerBtn,
                'z-30': hasManualDrawerBtn,
            }"
            :style="{
                top: headerHeight + 'px',
                height: 'calc(100vh - ' + headerHeight + 'px)',
                width,
            }"
        >
            <slot />

            <!-- <div
                v-if="hasManualDrawerBtn"
                class="absolute right-0 top-0 cursor-pointer p-2"
                @click="store.mobileLeftPanelOpen = false"
            >
                <i class="pi pi-times text-2xl" />
            </div> -->
        </div>
        <div
            v-if="hasManualDrawerBtn"
            class="fixed bottom-0 left-0 z-40 flex w-full transform cursor-pointer items-center justify-center gap-1 border-t border-black-text bg-white p-1.5 text-center shadow-lg print:hidden"
            @click="store.mobileLeftPanelOpen = !store.mobileLeftPanelOpen"
        >
            <span class="font-promedium"> {{ $t("general.obsah") }} </span>
            <i
                class="pi pi-angle-double-up relative bottom-px duration-300"
                :class="{
                    'rotate-180': store.mobileLeftPanelOpen,
                }"
            />
        </div>
    </Teleport>
</template>

<script lang="ts" setup>
const {
    active,
    direction = "from-right",
    width = "100vw",
    hasManualDrawerBtn = false,
} = defineProps<{
    active: boolean
    direction?: "from-left" | "from-right" | "from-bottom"
    width?: string
    hasManualDrawerBtn?: boolean
}>()

const headerHeight = 85

const store = useMainStore()

onMounted(() => {
    store.hasMobileLeftPanel = direction === "from-left"
})
onUnmounted(() => {
    store.hasMobileLeftPanel = false
})
</script>

<style scoped></style>
